import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "src/components/ui/alert";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "src/components/ui/tooltip";
import { selectZenfitAutomation } from "src/redux/slices/automationsSlice";
import { useSelector } from "src/redux/store";

// Shared default text
const DEFAULT_TOOLTIP_TEXT = "Unfortunately Zenfit no longer wish to support the Zenfit automation feature. The Zenfit automation feature will be discontinued on Friday, 6th of June and will be removed soon. You don't need to do anything.";
const DEFAULT_ALERT_TITLE = "Feature Deprecation";
export const DEFAULT_ALERT_DESCRIPTION = "Unfortunately Zenfit no longer wish to support the Zenfit automation feature. The Zenfit automation feature will be discontinued on Friday, 6th of June and will be removed soon. You don't need to do anything. In the mean time we are working on new awesome invite automations to put your reviews on auto pilot";

interface DeprecationIconProps {
    tooltipText?: string;
    iconClassName?: string; // Allow customizing icon style
}

export function ZenfitDeprecationIcon({
    tooltipText = DEFAULT_TOOLTIP_TEXT,
    iconClassName = "h-5 w-5 text-yellow-500 cursor-help"
}: DeprecationIconProps) {
    const automation = useSelector(selectZenfitAutomation);
    const hasZenfitAutomation = automation?.id;
    if (!hasZenfitAutomation) return null;
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="inline-flex items-center justify-center">
                        <AlertTriangle className={iconClassName} />
                    </span>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{tooltipText}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}

interface DeprecationAlertProps {
    alertTitle?: string;
    alertDescription?: string;
    iconClassName?: string; // Allow customizing icon style in alert
}

export function ZenfitDeprecationAlert({
    alertTitle = DEFAULT_ALERT_TITLE,
    alertDescription = DEFAULT_ALERT_DESCRIPTION,
    iconClassName = "h-4 w-4" // Default for alert
}: DeprecationAlertProps) {
    const automation = useSelector(selectZenfitAutomation);
    const hasZenfitAutomation = automation?.id;
    if (!hasZenfitAutomation) return null;
    return (
        <Alert variant="destructive">
            <AlertTriangle className={iconClassName} />
            <AlertTitle>{alertTitle}</AlertTitle>
            <AlertDescription>{alertDescription}</AlertDescription>
        </Alert>
    );
}

// You can now import these components individually:
// import { DeprecationIcon, DeprecationAlert } from './path/to/deprecateWarning';
